import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { Group } from 'views/App/Portal/LexID/Groups/_types/group';

export default function useGroup(
  organizationId?: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups`;
  return useQuery<Group, ServerErrorResponse>(
    ['group', organizationId, id],
    async () => {
      if (!organizationId || !id) {
        throw new Error('organizationId and id are required parameters');
      }

      try {
        const data = await fetcher({
          url: `${url}/${id}`,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      keepPreviousData: false,
      enabled: !!organizationId && !!id,
    }
  );
}
